import { render, staticRenderFns } from "./TaskPointAverage.vue?vue&type=template&id=5a000f5c&scoped=true"
import script from "./TaskPointAverage.vue?vue&type=script&lang=js"
export * from "./TaskPointAverage.vue?vue&type=script&lang=js"
import style0 from "./TaskPointAverage.vue?vue&type=style&index=0&id=5a000f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a000f5c",
  null
  
)

export default component.exports